import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=13fc7928"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=13fc7928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports